// src/app/core/auth/auth.initializer.ts
import { inject, provideAppInitializer } from '@angular/core';
import { AuthFacade } from './auth-facade';

export function provideAuthInitializer() {
  return provideAppInitializer(() => {
    const authFacade = inject(AuthFacade);
    return authFacade.checkSession();
  });
}